module.exports = __webpack_public_path__ + "196b3d44e1bbb13680eae2b69147a02b.MP3";